import { render, staticRenderFns } from "./unionRoleAuthEdit.vue?vue&type=template&id=520a8117&scoped=true&"
import script from "./unionRoleAuthEdit.vue?vue&type=script&lang=js&"
export * from "./unionRoleAuthEdit.vue?vue&type=script&lang=js&"
import style0 from "./unionRoleAuthEdit.vue?vue&type=style&index=0&id=520a8117&lang=less&scoped=true&"
import style1 from "./unionRoleAuthEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a8117",
  null
  
)

component.options.__file = "unionRoleAuthEdit.vue"
export default component.exports